// Async agentic chat.
// Values are tunable — confirm final cadence in design review.

// Real-time event_type that signals the agent run finished and the answer can be fetched.
export const DONE_EVENT_TYPE = 'done';

// Poll cadence while processing. When the real-time subscription is connected the `done` event is the
// primary resolution path, so polling backs off to a slow safety net (once a minute); when it's down,
// polling is the only way to learn the result, so it runs at the faster cadence.
export const ASYNC_POLL_INTERVAL_MS = 15 * 1000;
export const ASYNC_POLL_INTERVAL_CONNECTED_MS = 60 * 1000;

// Retries for the `done` fast-path fetch after a transient failure (no response, 429, 5xx), one every
// ASYNC_POLL_INTERVAL_MS. The `done` event fires only once, so without them a single failure waits for
// the next poll — a minute away while the subscription is connected.
export const ASYNC_FETCH_RETRIES = 3;

// Statuses the `done`-path fetch treats as transient: 429 and anything from 500 up.
export const HTTP_STATUS = {
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
} as const;

// Escape hatch for a run the backend leaves stuck in `processing` (crashed/hung agent): after this
// much wall-clock with no terminal status we surface `failed` so the Retry affordance appears and the
// input is no longer permanently disabled. Max poll attempts are derived from the active interval, so
// this ~15 min ceiling holds at either cadence.
export const ASYNC_POLL_TIMEOUT_MS = 15 * 60 * 1000;

// claims_llm ExchangeStatus values. Surfaced by the pass-through GET and also used for the
// client-side exchange state (which only ever holds PROCESSING or FAILED — COMPLETED clears it).
export const ASYNC_EXCHANGE_STATUS = {
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

// The subset of statuses the client-side async exchange state can hold.
export type AsyncExchangeClientStatus = typeof ASYNC_EXCHANGE_STATUS.PROCESSING | typeof ASYNC_EXCHANGE_STATUS.FAILED;
